import {
  FlowlineSettings,
  ActivitySettings,
  ActivityType,
  DiagramGeneralSettings,
  PositionType
} from '../diagram-type-styles.model';
import {FlowlineForm} from '../flowline-form.enum';
import {IAttributeJson} from 'src/app/diagram-data/diagram-json-handler.service';
import {ArchitectureBaseConfig} from './diagram-architecture-base-config';
import {MAPS_TYPES_ENUM as MAP_TYPES} from '../../../editor-interface/shared/models/map.model';

export class CapabilityConfig extends ArchitectureBaseConfig {
  generalSettings(): DiagramGeneralSettings {
    return {
      ...super.generalSettings(),
      tagName: 'Capability Map',
      tagColor: '#052142',
      allowedDrilldownSubtypes: [
        MAP_TYPES.CAPABILITY,
        MAP_TYPES.SYSTEM_ARCHITECTURE,
        MAP_TYPES.DATA_MODEL,
        MAP_TYPES.INTERACTION_FLOW,
        MAP_TYPES.UPN,
        MAP_TYPES.CUSTOMER_JOURNEY
      ]
    };
  }

  readonly activityShape = {w: 200, h: 210};
  readonly activityText = 'Business Capability';
  readonly activityTypes: ActivityType[] = [
    {
      tooltip: 'ASIDE_L.CAPABILITY_DEFAULT_ACTIVITY_TOOLTIP',
      icon: 'activity_icon_v4',
      settings: (x?: number, y?: number) => this.activitySettings(x, y)
    },
    {
      tooltip: 'ASIDE_L.CAPABILITY_EMPTY_ACTIVITY_TOOLTIP',
      icon: 'activity_icon_v3',
      settings: (x?: number, y?: number) => this.activitySettingsWithoutInfo(x, y)
    }
  ];

  activitySettings(x?: number, y?: number): ActivitySettings {
    const defaultAttributes: IAttributeJson[] = [
      {mxKey: 1, text: 'Attribute 1'},
      {mxKey: 2, text: 'Attribute 2'},
      {mxKey: 3, text: 'Attribute 3'}
    ];

    return {
      ...super.activitySettings(x, y),
      text: this.activityText,
      footerText: 'Provide short description...',
      defaultAttributes
    };
  }

  activitySettingsWithoutInfo(x?: number, y?: number): ActivitySettings {
    const emptyActivityShape = {w: 200, h: 100};

    return {
      ...super.activitySettings(x, y),
      text: this.activityText,
      defaultActivityShape: emptyActivityShape,
      position: this.getPosition(emptyActivityShape, x, y, PositionType.CENTER),
      dragHandlePosition: this.getPosition(emptyActivityShape, x, y, PositionType.DEFAULT)
    };
  }

  flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings {
    return {
      ...super.flowlineSettings(x, y, id),
      form: {
        shape: FlowlineForm.shape.Orthogonal,
        type: FlowlineForm.type.Solid,
        start: FlowlineForm.end.None,
        end: FlowlineForm.end.FullArrow
      }
    };
  }
}
